export default __webpack_public_path__ + "static/media/explore-analogous-inspiration.f1213f97.svg";